package org.vreo.devicehub.features.core.domain.device.vrmConfig

/**
 * Vrm type
 *
 * @property value string defining type of vrm target
 */
enum class VrmOutputType(val value: String) {
    OTHER("OTHER"),
    ZATPARK("zatpark_https"),
    APT("apt"),
    SUREPARK("surepark")

}
